/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImageUploadResult } from '../../models/image-upload-result';

export interface ImagesControllerResizeAndStoreImageFile$Params {
}

export function imagesControllerResizeAndStoreImageFile(http: HttpClient, rootUrl: string, params?: ImagesControllerResizeAndStoreImageFile$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageUploadResult>> {
  const rb = new RequestBuilder(rootUrl, imagesControllerResizeAndStoreImageFile.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImageUploadResult>;
    })
  );
}

imagesControllerResizeAndStoreImageFile.PATH = '/images/resizeAndStoreImage';
